import { createTheme, Grid, ThemeProvider, Button, TableRow, TableCell, Table, TableHead, TableBody, IconButton, Typography, InputBase, FormControl, Tooltip, InputAdornment, OutlinedInput } from "@material-ui/core"
import * as React from "react"
import useStyles from "../maintenance/assets/styles";
import { AddIconLarge, AddIconTwo, CloseIcon, DownArrow, EditIcon, Info, PlusIcon, QuestionIcon, ToggleOffIcon, ToggleOnIcon, TooltipIcon, TrashIcon, UpArrow, ViewIcon, WarningIcon } from "src/components/Icons";
import { useState, useEffect } from "react";
import { DropDown } from "../maintenance/test-automation/components/DropDown";
import { DialogPopup } from "../maintenance/test-automation/components/DialogPopup";
import { deleteWebhook, fetchBatchNumbers, fetchDevices, getAllWebhook, getAllDevices, fetchAllDevices, createWebhook, updateWebhook } from "../maintenance/test-automation/components/apiHelper";
import { ToasterComponent } from "../maintenance/test-automation/components/Toaster";
import { Loader } from "../maintenance/test-automation/components/Loader";
import { filter } from "rxjs/operators";
import { createFalse } from "typescript";
import { Visibility, VisibilityOff } from "@material-ui/icons";

export const WebhookComponent = () => {
    const classes = useStyles()
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const [webookDetails, setWebhookDetails] = useState([])
    const [isAddWebhook, setIsAddWebhook] = useState(false)
    const [batches, setBatches] = useState([])
    const [devices, setDevices] = useState([])
    const [isAccessTokenAvailable, setIsAccessTokenAvailable] = useState(true)
    const [selectedBatches, setSelectedBatches] = useState([])
    const [selectedDevices, setSelectedDevices] = useState([])
    const [errors, setErrors] = useState(
        {
            batchError: "", deviceError: "", nameError: "", accessTokenError: "", apiUrlError: "",
            usernameError: "", passwordError: "", clientIdError: "", clientSecretError: "", grantTypeError: "",
            configurationNameError: "", oauthUrlError: ""
        })
    const [webhook, setWebhook] = useState({ name: "", apiUrl: "", accessToken: "", accessTokenAvailable: true, grantType: '', clientId: '', clientSecret: '', username: '', password: '', configurationName: '', oauthUrl: '' })
    const [isDeleteWebhook, setIsDeleteWebhook] = useState(false)
    const [selectedWebhook, setSelectedWebhook] : any =  useState({})
    const [optionDevices, setOptionDevices] = useState([])
    const [selectedGrantType, setSelectedGrantType] = useState('')
    const [webhookType, setWebhookType] = useState('')
    const [selectedWebhookName, setSelectedWebhookName] = useState('')
    const [webhookId, setWebhookId] = useState("")
    const [crederentialDetails, setCredentialDetails] = useState({})
    const [disableComponent, setDisableComponent] = useState({ device: true, name: true, apiUrl: true, accessToken: true, toggleButton: true, grantType: true, oauthUrl: true, clientId: true, clientSecret: true, username: true, password: true, configurationName: true })
    const [isUpdateDisabled,setIsUpdateDisabled] = useState(false)
    const fieldOrder = [
        "name",
        "apiUrl",
        "accessToken",
        "configurationName",
        "oauthUrl",
        "clientId",
        "clientSecret",
        "username",
        "password"
    ];
    //Loader
    const [loading, setLoading] = useState(false)

    //Toaster
    const [isToasterOpen, setIsToasterOpen] = useState(false)
    const [toasterMessage, setToasterMessage] = useState("")
    const [reqSuccess, setReqSuccess] = useState(false)

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true)
                await Promise.all([
                    getWebhooks(),
                    getAllBatches(),
                    getDevices()
                ]);

            } catch (error) {
                showToast({ success: false, message: error.message })
            } finally {
                setLoading(false)
            }
        }
        loadData()
    }, [])

    const getAllBatches = async () => {
        const batch = await fetchBatchNumbers()
        setBatches(batch)
    }

    const getDevices = async () => {
        const device = await fetchAllDevices()
        setDevices(device)
    }


    const getWebhooks = async () => {
        const webhooks = await getAllWebhook();
        setWebhookDetails(webhooks)
    }

    const handleDeleteWebhook = async () => {
        setLoading(true)
        try {
            await deleteWebhook(webhookId)
            setIsDeleteWebhook(false)
            showToast({ success: true, message: 'Webhook delete successfully.' })
            getWebhooks()
        } catch (error) {
            setIsDeleteWebhook(false)
            showToast({ success: false, message: error.message ? error.message : 'Webhook delete failed.' })
        } finally {
            setLoading(false)
        }
    }

    const handleCancelDelete = (webhook) => {
        const isDelete = isDeleteWebhook
        if (!isDelete) {
            setIsDeleteWebhook(true)
            setSelectedWebhook(webhook)
            setSelectedWebhookName(webhook.name)
            setWebhookId(webhook.id)
        } else {
            setIsDeleteWebhook(false)
        }
    }

    const showToast = (opts: { success: boolean; message: string }) => {
        setReqSuccess(opts.success);
        setToasterMessage(opts.message);
        setIsToasterOpen(true);
        setTimeout(() => setIsToasterOpen(false), 2500);
    };

    const handleNewWebhook = () => {
        setWebhookType('add')
        if (isAddWebhook) {
            setIsAddWebhook(false)
        } else {
            setIsAddWebhook(true)
        }
    }

    const handleEditWebhook = (webhook) => {
        setWebhookType('edit')
        setSelectedWebhook(webhook)
        setSelectedBatches(webhook.batchNumbers)
        setSelectedDevices(webhook.deviceIds)
        setDisableComponent(
            {device:false,name:false,apiUrl:false,accessToken:!webhook.accessTokenAvailable,toggleButton:false,
                grantType:false,oauthUrl:false,clientId:false,clientSecret:false,username:false,
                password:false,configurationName:false
            }
        )
        setWebhook({
            name: webhook.name,
            apiUrl: webhook.apiUrl,
            accessToken: webhook.accessToken,
            accessTokenAvailable: webhook.accessTokenAvailable == null ? true : webhook.accessTokenAvailable,
            grantType: webhook.grantType ? webhook.grantType : '',
            clientId: webhook.clientId ? webhook.clientId : '',
            clientSecret: webhook.clientSecret ? webhook.clientSecret : '',
            username: webhook.username ? webhook.username : '',
            password: webhook.password ? webhook.password : '',
            configurationName: webhook.configurationName ? webhook.configurationName : '',
            oauthUrl: webhook.oauthUrl ? webhook.oauthUrl : ''
        })
        const optionDevice = devices.filter(device => webhook.batchNumbers.includes(device.batchNumber)&& !webhook.deviceIds.includes(device.id))
        setOptionDevices(optionDevice)

        if (isAddWebhook) {
            setIsAddWebhook(false)
            setSelectedWebhook({})
        } else {
            setIsAddWebhook(true)
        }
    }

    const handleSelectBatch = (batch) => {
        setSelectedBatches(batch)
        if (batch.length === 0) {
            // Disable everything
            setDisableComponent({
                device: true,
                name: true,
                apiUrl: true,
                accessToken: true,
                toggleButton: true,
                grantType: true,
                oauthUrl: true,
                clientId: true,
                clientSecret: true,
                username: true,
                password: true,
                configurationName: true
            });

            setOptionDevices([]);
            return;
        }
        const filterDevice = devices.filter(device => batch.includes(device.batchNumber))
        setOptionDevices(filterDevice)
        setErrors((prevError) => ({
            ...prevError,
            batchError: ""
        }))
        setDisableComponent((prev) => ({
            ...prev,
            device: false
        }))
    }

    const removeSelectedBatch = (batch) => {
        setSelectedBatches((prevBatches) =>
            prevBatches.filter((b) => b !== batch)
        )
    }

    const handleSelectDevice = (device) => {
        setSelectedDevices((prevDevices) => {
            if (prevDevices.includes(device)) {
                return prevDevices
            }
            return [...prevDevices, device]
        })
        setOptionDevices((prevDevices) =>
            prevDevices.filter((d) => d.id !== device)
        );
        setErrors((prevError) => ({
            ...prevError,
            deviceError: ""
        }))
        setDisableComponent((prev) => ({
            ...prev,
            name: false
        }))
    }

    const removeSelectedDevice = (device) => {
        setSelectedDevices((prevDevices) => {
            let updatedDevices;

            if (prevDevices.includes(device)) {
                updatedDevices = prevDevices.filter((d) => d !== device);
            }
            if (updatedDevices.length === 0) {
                setDisableComponent((prev) => {
                    const updated = { ...prev };
                    fieldOrder.forEach((key) => (updated[key] = true));
                    updated.toggleButton = true;
                    return updated;
                });
            } else {
                setDisableComponent((prev) => ({
                    ...prev,
                    name: false
                }));
            }

            return updatedDevices;
        });

        const optionDevice = devices.find(d => d.id == device)
        setOptionDevices((prevDevice) => ([
            ...prevDevice,
            optionDevice
        ]))
    }

    const handleWebhookName = (e) => {
        const { value, name } = e.target
        setWebhook((prevWebhook) => ({
            ...prevWebhook,
            [name]: value
        }))
        const index = fieldOrder.indexOf(name);
        if (index === -1) return; // not part of the chain → no logic needed

        const nextFields = fieldOrder.slice(index + 1);

        setDisableComponent((prev) => {
            const updated = { ...prev };

            if (value !== "") {
                // enable only next immediate field
                if (fieldOrder[index + 1]) {
                    updated[fieldOrder[index + 1]] = false;
                }
            } else {
                // disable all fields that come after this one
                nextFields.forEach((key) => (updated[key] = true));
            }

            if(name == 'apiUrl'){
                updated.toggleButton = false
            }

            return updated;
        });

        setErrors((prevError) => ({
            ...prevError,
            [`${name}Error`]: ""
        }));
    }

    const handleAccessTokenAvailable = () => {
        let isAvailable = webhook.accessTokenAvailable;
        if (isAvailable) {
            // setIsAccessTokenAvailable(false)
            setWebhook((prev) => ({
                ...prev,
                accessTokenAvailable: false
            }))
            setDisableComponent((prev) => ({
                ...prev,
                accessToken: true
            }))
            setErrors((prevError) => ({
                ...prevError,
                accessTokenError: ""
            }))
        } else {
            setWebhook((prev) => ({
                ...prev,
                accessTokenAvailable: true
            }))
            setDisableComponent((prev) => ({
                ...prev,
                grantType: false,
                accessToken: false
            }))
            setErrors((prevError) => ({
                ...prevError,
                grantTypeError: "",
                clientIdError: "",
                clientSecretError: "",
                usernameError: "",
                passwordError: ""
            }))
        }
    }

    function prepareWebhookPayload(webhook: any, selectedBatches: any[], selectedDevices: any[]) {
        const payload = {
            ...webhook,
            batchNumbers: selectedBatches,
            deviceIds: selectedDevices,
        };

        // Rule 1: If access token is available → ignore grantType + config fields
        if (payload.accessTokenAvailable === true) {
            [
                "grantType",
                "configurationName",
                "username",
                "password",
                "clientId",
                "clientSecret",
                "oauthUrl"
            ].forEach((key) => delete payload[key]);
        }

        // Rule 2: If grantType is credential → ignore clientId + clientSecret
        if (payload.grantType === "Credential") {
            ["username", "password"].forEach((key) => delete payload[key]);
        }

        // Rule 3: If access token is NOT available → ignore accessToken
        if (payload.accessTokenAvailable === false) {
            payload.accessToken = "";
        }

        return payload;
    }

    const handleAddWebhook = async () => {
        const newWebhook = prepareWebhookPayload(webhook, selectedBatches, selectedDevices)
        const isValid = await validateForm()
        if (Object.keys(isValid).length > 0) {
            return;
        }

        try {
            setLoading(true)
            const result = webhookType == 'add' ? await createWebhook(newWebhook) : await updateWebhook(newWebhook,selectedWebhook.id)
            setIsAddWebhook(false)
            resetForm()
            getWebhooks()
            showToast({ success: true, message:webhookType == 'add'? 'Webhook created successfully.' : 'Webhook updated successfully.'})
        } catch (error) {
            showToast({ success: false, message: error.message ? error.message : webhookType == 'add' ? 'Webhook create failed.': 'Webhook update failed' })
        } finally {
            setLoading(false)
        }
    }

    const validateForm = () => {
        let error: any = {};

        // ===== 1. Basic Required Fields =====
        const baseRequired = [
            { value: selectedBatches, key: "batchError", msg: "Selecting a batch is required", isArray: true },
            { value: selectedDevices, key: "deviceError", msg: "Selecting at least one device is required", isArray: true },
            { value: webhook.name, key: "nameError", msg: "Entering webhook name is required" },
            { value: webhook.apiUrl, key: "apiUrlError", msg: "Entering API URL is required" }
        ];

        if (webhook.accessTokenAvailable) {
            baseRequired.push({
                value: webhook.accessToken,
                key: "accessTokenError",
                msg: "Entering Access Token is required"
            });
        }

        baseRequired.forEach((item) => {
            if (item.isArray ? item.value.length === 0 : item.value === "") {
                error[item.key] = item.msg;
            }
        });

        // ===== 2. OAuth Required Fields =====
        if (!webhook.accessTokenAvailable) {
            const oauthRequired = [
                { value: webhook.grantType, key: "grantTypeError", msg: "Selecting grant type is required" },
                { value: webhook.configurationName, key: "configurationNameError", msg: "Entering Configuration Name is required" },
                { value: webhook.oauthUrl, key: "oauthUrlError", msg: "Entering Oauth URL is required" },
            ];

            oauthRequired.forEach((item) => {
                if (item.value === "") {
                    error[item.key] = item.msg;
                }
            });

            // ===== 3. Grant-Type Specific =====
            if (selectedGrantType === "Credential") {
                const passkeyRequired = [
                    { value: webhook.clientSecret, key: "clientSecretError", msg: "Entering Client Secret is required" },
                    { value: webhook.clientId, key: "clientIdError", msg: "Entering Client ID is required" },
                ];

                passkeyRequired.forEach((item) => {
                    if (item.value === "") {
                        error[item.key] = item.msg;
                    }
                });
            }

            if (selectedGrantType === "Passkey") {
                const credentialRequired = [
                    { value: webhook.username, key: "usernameError", msg: "Entering Username is required" },
                    { value: webhook.password, key: "passwordError", msg: "Entering Password is required" },
                    { value: webhook.clientSecret, key: "clientSecretError", msg: "Entering Client Secret is required" },
                    { value: webhook.clientId, key: "clientIdError", msg: "Entering Client ID is required" },
                ];

                credentialRequired.forEach((item) => {
                    if (item.value === "") {
                        error[item.key] = item.msg;
                    }
                });
            }
        }

        const isNameExistInWebhook = webookDetails.some(
            (w) => w.id !== selectedWebhook.id && w.name.toLowerCase() === webhook.name.toLowerCase().trim()
        );

        if (isNameExistInWebhook) {
            error.nameError = "Name already exists."
        }

        const isApiUrlExist = webookDetails.some(
            (w) => w.id !== selectedWebhook.id && w.apiUrl.trim().toLowerCase() === webhook.apiUrl.trim().toLowerCase()
        );

        if (isApiUrlExist) {
            error.apiUrlError = "API URL already exists."
        }

        const deviceExist = webookDetails.some((w) => 
            w.id !== selectedWebhook.id 
            && w.apiUrl === webhook.apiUrl 
            && selectedDevices.some((d) => w.deviceIds.includes(d)
        ))

        if (deviceExist) {
            error.deviceError = "Device is already assigned to a webhook with the same API URL."
        }

        setErrors(error);
        return error;
    };

    const handleCloseWebhook = () => {
        setIsAddWebhook(false)
        resetForm()
        // setErrors({})
    }
    const handleSelectGrantType = (grantType) => {
        setSelectedGrantType(grantType)
        setWebhook((prev) => ({
            ...prev,
            grantType: grantType
        }))
        setDisableComponent((prev) => ({
            ...prev,
            configurationName: false,
            oauthUrl: false,
            clientId: false,
        }))
        setErrors((prevError) =>({
            ...prevError,
            grantTypeError:""
        }))
    }

    const resetForm = () => {
        setWebhook({ name: "", apiUrl: "", accessToken: "", accessTokenAvailable: true, grantType: '', clientId: '', clientSecret: '', username: '', password: '', configurationName: '', oauthUrl: '' })
        setSelectedBatches([])
        setSelectedDevices([])
        setOptionDevices([])
        setIsAccessTokenAvailable(true)
        setErrors(
            {
                batchError: "", deviceError: "", nameError: "", accessTokenError: "", apiUrlError: "",
                usernameError: "", passwordError: "", clientIdError: "", clientSecretError: "", grantTypeError: "",
                oauthUrlError: '', configurationNameError: ''
            })

        setDisableComponent(
            {device:true,name:true,apiUrl:true,accessToken:true,toggleButton:true,
                grantType:true,oauthUrl:true,clientId:true,clientSecret:true,username:true,
                password:true,configurationName:true
            }
        )
    }

    useEffect(() => {
        if (selectedBatches.length == 0) {
            setSelectedDevices([])
        }
    }, [selectedBatches])

    const isWebhookChanged = (oldWebhook, newWebhook) => {
        return JSON.stringify(oldWebhook) !== JSON.stringify(newWebhook);
    };

    useEffect(() => {
        if (webhookType === 'edit') {
            const { id, accessTokenAvailable, ...rest } = selectedWebhook;
            const oldData = {
                ...rest,
                batchNumbers: selectedBatches,
                deviceIds: selectedDevices
            };

            const newData = {
                ...webhook,
                batchNumbers: selectedBatches,
                deviceIds: selectedDevices
            };
            setIsUpdateDisabled(!isWebhookChanged(oldData, newData));
        }
    }, [webhook, selectedBatches, selectedDevices]);

    return (
        <ThemeProvider theme={theme} >
            <Grid container style={{ padding: '25px' }}>
                <Grid container justifyContent="center" alignItems="center" >
                    <Grid item xs={3} md={3} style={{ width: "100%", textAlign: "center", backgroundColor: '#FFFFFF', paddingTop: '10px' }}>
                        Webhook
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} style={{ display: 'flex', justifyContent: "flex-end" }}>
                    <Button startIcon={<AddIconTwo color='#FFFFFF' />} variant="contained" style={{ backgroundColor: "#2A7BEC", color: 'white' }} onClick={handleNewWebhook}>Add New Webhook</Button>
                </Grid>
                <Table className={classes.tableContainer}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Webhook Name</TableCell>
                            <TableCell>API URL</TableCell>
                            <TableCell>Access Token</TableCell>
                            <TableCell>Grant Type</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {webookDetails.length > 0 ?
                            webookDetails.map((webhook, index) => (
                                <React.Fragment key={index}>
                                    <TableRow style={{ backgroundColor: index % 2 == 0 ? '#FFFFFF' : '#F5F5F5' }}>
                                        <TableCell>{webhook.name}</TableCell>
                                        <TableCell>
                                            <Tooltip title={webhook.apiUrl}>
                                                <Typography>
                                                    {webhook.apiUrl.length > 20 ? webhook.apiUrl.substring(0, 20) + "..." : webhook.apiUrl}
                                                </Typography>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            {webhook.accessTokenAvailable && 
                                                <Tooltip title={webhook.accessToken}>
                                                    <Typography>
                                                        {webhook.accessToken.length > 20 ? webhook.accessToken.substring(0, 20) + "..." : webhook.accessToken}
                                                    </Typography>
                                                </Tooltip>
                                            }   
                                        </TableCell>
                                        <TableCell>{webhook.grantType}</TableCell>
                                        <TableCell className={classes.statusCell}>
                                            {(() => {
                                                const isSuccess = webhook.apiResponseStatus ? (webhook.apiResponseStatus == 200  || webhook.oauthApiResponseStatus == 201)? true : false : "N/A";
                                                return (
                                                    <Grid container style={{ alignItems: 'center' }}>
                                                        <Grid item className={!isSuccess || isSuccess == "N/A" ? classes.disableText : classes.enableText}>
                                                            {isSuccess == "N/A" ? "N/A" : isSuccess ? 'Success' : 'Failure'}
                                                        </Grid>
                                                        {(isSuccess === false || isSuccess === "N/A") && (
                                                            <Tooltip
                                                                title={
                                                                isSuccess === "N/A"
                                                                    ? "Response not available"
                                                                    : (<>
                                                                            <span>
                                                                                {`code: ${webhook.apiResponseStatus}`}
                                                                            </span>
                                                                            <br />
                                                                            <span>
                                                                                {`message: ${webhook.apiResponseBody}`}
                                                                            </span>
                                                                        </>
                                                                    )
                                                                }
                                                            >
                                                                <span>
                                                                    <Info />
                                                                </span>
                                                            </Tooltip>
                                                            )}

                                                    </Grid>
                                                );
                                            })()}
                                        </TableCell>

                                        <TableCell align="center">
                                            <IconButton size={'small'} onClick={() => handleEditWebhook(webhook)}>
                                                <EditIcon stroke='#868DAA' />
                                            </IconButton>
                                            <IconButton size={'small'} onClick={() => handleCancelDelete(webhook)}>
                                                <TrashIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))
                            : (
                                <TableRow style={{ backgroundColor: '#FFFFFF' }}>
                                    <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                                        No Webhook Available
                                    </TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                </Table>
            </Grid>
            <DialogPopup
                open={isAddWebhook}
                title={webhookType == "add" ?'Add new webhook' : 'Edit Webhook'}
                dialogContent={<AddWebhook
                    batches={batches}
                    handleSelectBatch={handleSelectBatch}
                    selectedBatches={selectedBatches}
                    devices={optionDevices.map(device => device.id)}
                    selectedDevices={selectedDevices}
                    handleSelectDevice={handleSelectDevice}
                    removeDevice={removeSelectedDevice}
                    webhook={webhook}
                    handleWebhookName={handleWebhookName}
                    errors={errors}
                    isAccessTokenAvailable={isAccessTokenAvailable}
                    handleAccessTokenAvailable={handleAccessTokenAvailable}
                    selectedGrantType={selectedGrantType}
                    handleSelectGrantType={handleSelectGrantType}
                    disableComponent={disableComponent}
                />}
                buttonRequired={true}
                cancel='cancel'
                submit={webhookType == "edit" ? 'update' : 'add'}
                submitButtonColor='#2A7BEC'
                onSubmit={handleAddWebhook}
                onClose={handleCloseWebhook}
                disable={webhookType == "edit" ? isUpdateDisabled : false}
            />

            <DialogPopup
                open={isDeleteWebhook}
                title='conformation'
                dialogContent={`Are you sure you want to delete ${selectedWebhookName}?`}
                buttonRequired={true}
                cancel='cancel'
                onClose={handleCancelDelete}
                submit='delete'
                submitButtonColor='#FF4343'
                onSubmit={handleDeleteWebhook}
            />
            <Loader loading={loading} />
            <ToasterComponent
                reqSuccess={reqSuccess}
                message={toasterMessage}
                toaster={isToasterOpen}
            />



        </ThemeProvider>
    )
}

export const AddWebhook = ({
    batches,
    handleSelectBatch,
    selectedBatches,
    devices,
    selectedDevices,
    handleSelectDevice,
    removeDevice,
    webhook,
    handleWebhookName,
    errors,
    isAccessTokenAvailable,
    handleAccessTokenAvailable,
    selectedGrantType,
    handleSelectGrantType,
    disableComponent
}) => {
    const style = useStyles()
    const [showDeviceOptions, setShowDeviceOptions] = useState(false)
    const [grantTypes, setGrantTypes] = useState(["Passkey", "Credential"])
    const [showPassword,setShowPassword] = useState(false)
    const togglePassword = () => setShowPassword(!showPassword);
    return (
        <Grid container>
            <Grid container className={style.webhookContainer}>
                <Grid item xs={12} md={12} className={style.label}>
                    Batch Name:
                    <span style={{ color: 'red' }}>*</span>
                </Grid>
                <Grid item xs={12} md={12}>
                    <DropDown
                        options={batches}
                        type='batch'
                        emptyTag='-Select-'
                        setSelectOption={handleSelectBatch}
                        value={selectedBatches}
                        isSingle={false}
                    />
                    {errors.batchError && (
                        <Grid container justifyContent="flex-end" alignItems="center" >
                            <Typography className={style.errorText}>
                                {errors.batchError}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            <Grid container className={style.webhookContainer}>
                <Grid item xs={12} md={12} className={`${style.label} ${disableComponent.device ? style.disableGrid : ""}`}>
                    Devices
                    <span style={{ color: 'red' }}>*</span>
                </Grid>
                <Grid container style={{ border: '.75px solid rgba(63, 68, 81, .12156862745098039)', height: '80px', padding: '10px', overflowY: 'auto' }}>
                    {selectedDevices.map((device, index) => {
                        return (
                            <Grid container key={index} className={style.cloudItem}>
                                <Grid item className={style.cloudItem_number}>{index + 1}</Grid>
                                <Grid item className={style.cloudItem_line}></Grid>
                                <Grid item className={style.cloudItem_text}> {device}</Grid>
                                <Grid item onClick={() => removeDevice(device)} style={{ cursor: 'pointer' }}><CloseIcon color='#2A7BEC' /></Grid>
                            </Grid>
                        )

                    })

                    }
                </Grid>
                <FormControl className={`${style.input} actuator-dropdown`} onClick={() => setShowDeviceOptions(prev => !prev)} disabled={disableComponent.device}>
                    <Typography className={style.formInput}>
                        <span style={{ color: "grey" }}> Add Deivces </span>
                        {showDeviceOptions ? <UpArrow /> : <DownArrow />}
                    </Typography>
                    {showDeviceOptions && (
                        <Grid container className={style.dropDownGrid}>
                            {devices.map((device, index) => (
                                <Grid item xs={12} md={12}
                                    className={style.option}
                                    key={index}
                                    onClick={() => handleSelectDevice(device)}
                                >
                                    <span style={{ marginLeft: '10px' }}> {device} </span>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                    {errors.deviceError && (
                        <Grid container justifyContent="flex-end" alignItems="center" >
                            <Typography className={style.errorText}>
                                {errors.deviceError}
                            </Typography>
                        </Grid>
                    )}
                </FormControl>
            </Grid>
            <Grid container className={style.webhookContainer}>
                <Grid item xs={12} md={12} className={`${style.label} ${disableComponent.name ? style.disableGrid : ""}`}>
                    Webhook Name
                    <span style={{ color: 'red' }}>*</span>
                </Grid>
                <Grid item xs={12} md={12} style={{ marginBottom: "10px" }}>
                    <OutlinedInput
                        className={`${style.formInput} ${style.outLinedFormInput}`}
                        style={{ backgroundColor: '#FFFFFF' }}
                        type="text"
                        placeholder="Enter Webhook Name Here"
                        name="name"
                        value={webhook.name}
                        onChange={(e) => handleWebhookName(e)}
                        disabled={disableComponent.name}
                    />
                    {errors.nameError && (
                        <Grid container justifyContent="flex-end" alignItems="center" >
                            <Typography className={style.errorText}>
                                {errors.nameError}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            <Grid container spacing={2} className={style.webhookContainer}>
                <Grid item xs={12} md={6}>
                    <Grid container>
                        <Grid item xs={12} className={`${style.label} ${disableComponent.apiUrl ? style.disableGrid : ""}`}>
                            API URL <span style={{ color: 'red' }}>*</span>
                            {<Tooltip title = "Enter the destination URL for the data. If the URL must contain the device ID, insert {deviceID} at the required position.">
                                <span style={{marginLeft:'5px'}}>
                                    <QuestionIcon />
                                </span>
                            </Tooltip>}
                        </Grid>
                        <Grid item xs={12} style={{ marginBottom: "10px" }}>
                            <OutlinedInput
                                className={`${style.formInput} ${style.outLinedFormInput}`}
                                style={{ backgroundColor: '#FFFFFF' }}
                                type="text"
                                placeholder="https://api.example.com"
                                name="apiUrl"
                                value={webhook.apiUrl}
                                onChange={(e) => handleWebhookName(e)}
                                disabled={disableComponent.apiUrl}
                            />
                            {errors.apiUrlError && (
                                <Grid container justifyContent="flex-end" alignItems="center">
                                    <Typography className={style.errorText}>
                                        {errors.apiUrlError}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Grid container>
                        <Grid item xs={12} className={`${style.label} ${(disableComponent.accessToken || !webhook.accessTokenAvailable) ? style.disableGrid : ""}`} style={{pointerEvents:"auto"}}>
                                Access Token 
                                {(disableComponent.accessToken && !webhook.accessTokenAvailable) ? 
                                    <Tooltip title = "Generate Credentials' overrides manual access tokens. Any token entered here will not be used.">
                                        <span style={{marginLeft:'10px'}}>
                                            <Info stroke="#ff0505ff" width='15' height='15'/>
                                        </span>
                                    </Tooltip> 
                                    : <span style={{ color: 'red' }}>*</span>
                                }
                        </Grid>
                        <Grid item xs={12} style={{ marginBottom: "10px" }}>
                            <OutlinedInput
                                className={`${style.formInput} ${style.outLinedFormInput}`}
                                style={{ backgroundColor: '#FFFFFF' }}
                                type="text"
                                placeholder="Enter Access Token Here"
                                name="accessToken"
                                value={webhook.accessToken}
                                onChange={(e) => handleWebhookName(e)}
                                disabled={disableComponent.accessToken}
                            />
                            {(errors.accessTokenError && !disableComponent.accessToken) && (
                                <Grid container justifyContent="flex-end" alignItems="center">
                                    <Typography className={style.errorText}>
                                        {errors.accessTokenError}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container className={style.webhookContainer}>
                <Grid item xs={12} md={12} style={{ display: 'flex', justifyContent: "flex-end" }}>
                    Need to Generate Access Token ?
                    <IconButton onClick={handleAccessTokenAvailable} size={'small'} disabled={disableComponent.toggleButton}>
                        {webhook.accessTokenAvailable ? <ToggleOffIcon /> : <ToggleOnIcon />}
                    </IconButton>
                </Grid>
            </Grid>

            {!webhook.accessTokenAvailable &&
                <Grid container>
                    <Grid container spacing={2} className={style.webhookContainer}>
                        <Grid item xs={12} md={6}>
                            <Grid item xs={12} className={`${style.label} ${disableComponent.grantType ? style.disableGrid : ""}`}>
                                Grant Type
                                <span style={{ color: 'red' }}>*</span>
                            </Grid>
                            <Grid item xs={12}>
                                <DropDown
                                    options={grantTypes}
                                    type='grantType'
                                    emptyTag='-Select-'
                                    onClick={handleSelectGrantType}
                                    value={webhook.grantType}
                                    isSingle={true}
                                // disabled={disableComponent.grantType}
                                />
                                {errors.grantTypeError && (
                                    <Grid container justifyContent="flex-end" alignItems="center" >
                                        <Typography className={style.errorText}>
                                            {errors.grantTypeError}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid item xs={12} className={`${style.label} ${disableComponent.configurationName ? style.disableGrid : ""}`}>
                                Configuration Name
                                <span style={{ color: 'red' }}>*</span>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <OutlinedInput
                                    className={`${style.formInput} ${style.outLinedFormInput}`}
                                    style={{ backgroundColor: '#FFFFFF' }}
                                    type="text"
                                    placeholder="Enter configuration name here"
                                    name="configurationName"
                                    value={webhook.configurationName}
                                    onChange={(e) => handleWebhookName(e)}
                                    disabled={disableComponent.configurationName}
                                />
                                {errors.configurationNameError && (
                                    <Grid container justifyContent="flex-end" alignItems="center" >
                                        <Typography className={style.errorText}>
                                            {errors.configurationNameError}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} md={12}>
                            <Grid item xs={12} className={`${style.label} ${disableComponent.oauthUrl ? style.disableGrid : ""}`}>
                                Oauth URL
                                <span style={{ color: 'red' }}>*</span>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <OutlinedInput
                                    className={`${style.formInput} ${style.outLinedFormInput}`}
                                    style={{ backgroundColor: '#FFFFFF' }}
                                    type="text"
                                    placeholder="https://api.example.com"
                                    name="oauthUrl"
                                    value={webhook.oauthUrl}
                                    onChange={(e) => handleWebhookName(e)}
                                    disabled={disableComponent.oauthUrl}
                                />
                                {errors.oauthUrlError && (
                                    <Grid container justifyContent="flex-end" alignItems="center" >
                                        <Typography className={style.errorText}>
                                            {errors.oauthUrlError}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    {webhook.grantType != '' && <Grid container spacing={2} className={style.webhookContainer}>
                        <Grid item xs={12} md={6}>
                            <Grid item xs={12} className={`${style.label} ${disableComponent.clientId ? style.disableGrid : ""}`}>
                                Client ID
                                <span style={{ color: 'red' }}>*</span>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <OutlinedInput
                                    className={`${style.formInput} ${style.outLinedFormInput}`}
                                    style={{ backgroundColor: '#FFFFFF' }}
                                    type="text"
                                    placeholder="Enter Client Id Here"
                                    name="clientId"
                                    value={webhook.clientId}
                                    onChange={(e) => handleWebhookName(e)}
                                    disabled={disableComponent.clientId}
                                />
                                {errors.clientIdError && (
                                    <Grid container justifyContent="flex-end" alignItems="center" >
                                        <Typography className={style.errorText}>
                                            {errors.clientIdError}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid item xs={12} className={`${style.label} ${disableComponent.clientSecret ? style.disableGrid : ""}`}>
                                Client Secret
                                <span style={{ color: 'red' }}>*</span>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <OutlinedInput
                                    className={`${style.formInput} ${style.outLinedFormInput}`}
                                    style={{ backgroundColor: '#FFFFFF' }}
                                    type="text"
                                    placeholder="Enter Client Secret Here"
                                    name="clientSecret"
                                    value={webhook.clientSecret}
                                    onChange={(e) => handleWebhookName(e)}
                                    disabled={disableComponent.clientSecret}
                                />
                                {errors.clientSecretError && (
                                    <Grid container justifyContent="flex-end" alignItems="center" >
                                        <Typography className={style.errorText}>
                                            {errors.clientSecretError}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>}
                    {webhook.grantType == 'Passkey' && <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Grid item xs={12} className={`${style.label} ${disableComponent.username ? style.disableGrid : ""}`}>
                                Username
                                <span style={{ color: 'red' }}>*</span>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <OutlinedInput
                                    className={`${style.formInput} ${style.outLinedFormInput}`}
                                    style={{ backgroundColor: '#FFFFFF' }}
                                    type="text"
                                    placeholder="Enter Username Here"
                                    name="username"
                                    value={webhook.username}
                                    onChange={(e) => handleWebhookName(e)}
                                    disabled={disableComponent.username}
                                />
                                {errors.usernameError && (
                                    <Grid container justifyContent="flex-end" alignItems="center" >
                                        <Typography className={style.errorText}>
                                            {errors.usernameError}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid item xs={12} className={`${style.label} ${disableComponent.password ? style.disableGrid : ""}`}>
                                Password
                                <span style={{ color: 'red' }}>*</span>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <OutlinedInput
                                    className={`${style.formInput} ${style.outLinedFormInput}`}
                                    style={{ backgroundColor: '#FFFFFF',paddingLeft:'0px' }}
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter Password Here"
                                    name="password"
                                    value={webhook.password}
                                    onChange={(e) => handleWebhookName(e)}
                                    disabled={disableComponent.password}
                                    endAdornment={
                                        <InputAdornment position="end">
                                        <IconButton onClick={togglePassword} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                        </InputAdornment>
                                    }
                                />

                                {errors.passwordError && (
                                    <Grid container justifyContent="flex-end" alignItems="center" >
                                        <Typography className={style.errorText}>
                                            {errors.passwordError}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>

                    </Grid>}
                </Grid>
            }
        </Grid>
    )
}
